import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, inProcessOrdersActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, inProcessOrdersActions);

export default slice.reducer;
